import {SearchCardSection} from './SearchCardSection';
export default SearchCardSection;
